import { scroller } from "react-scroll";

// Custom hook to detect form field errors and scroll to them
const useDetectFieldError = ({ formik, projectActiveStep }) => {

  // Function to scroll to the first error field
  const scrollToError = ({ activeStepFields }) => {
    // Check if form is invalid or if there are any errors in the active step fields
    if (
      !formik.isValid ||
      Object.keys(formik?.errors)?.filter((item) =>
        activeStepFields?.includes(item)
      )?.length
    ) {
      // Filter the formik errors to only include those in the active step fields
      let filteredFields = Object?.fromEntries(
        Object.entries(formik?.errors)?.filter(([key]) =>
          activeStepFields?.includes(key)
        )
      );
      
      const firstKey = Object.keys(filteredFields)?.[0];

      // Scroll to the first error field
      scroller.scrollTo(firstKey, {
        duration: 300,
        delay: 100,
        smooth: "easeInOutQuint",
        offset: -160,
      });
    }
  };

  return { scrollToError };
};

export default useDetectFieldError;
